module.exports = __webpack_public_path__ + "a17d279f/img/splash-icon.07a7c465.svg";